import {addDays, format} from 'date-fns'

export const filters = () => ({
        price: [Infinity, 0],
        transferType: [],
        langCodes: [],
        name: null,
        cancellationPolicy: [],
        supplierName: [],
        productVariantId: [],
    }),
    searchRequest = () => ({
        convertToCurrency: null,
        departurePlace: null,
        departureCityId: null,
        departureCountryId: null,
        //departureHotelCode: null,
        arrivalPlace: null,
        arrivalCityId: null,
        arrivalCountryId: null,
        //arrivalHotelCode: null,
        adults: 1,
        childrenAges: [],
        dateTime: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        partialResponse: true,
    }),
    searchResponse = () => ({
        filters: filters(),
        product: [],
    })
